import MobileDatePicker from "@mui/lab/MobileDatePicker";
import DateAdapter from "@mui/lab/AdapterMoment";
import Close from "@mui/icons-material/Close";

import "moment/locale/sv";
//import moment from "moment";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { ThemeProvider } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { counties, kommuner } from "components/kommuner";
import LocationSelect from "components/LocationSelect";
import Notification from "components/Notification";
import { validateForm } from "components/validateForm";
import useUserProfile from "customhooks/useUserProfile";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { default as React, useEffect, useState } from "react";
import { getCategories, getCategoryById } from "./categoryHelper";
import { getJobTypes, getJobTypeById } from "./jobTypeHelper";
import theme from "./mainTheme";
import { SubCategories } from "./SubCategories";

export default function CreateOrUpdateAddDialog(props) {
  const today = new Date().toISOString().substring(0, 10);
  const [category, setCategory] = useState("el");
  const [county, setCounty] = useState("Stockholms län");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState("");
  const [id, setId] = useState(null);
  const [isZeroSix, setIsZeroSix] = useState(false);
  const [jobLength, setJobLength] = useState(1);
  const [municipality, setMunicipality] = useState(" - ");
  const [startDate, setStartDate] = useState(today);
  const [startNow, setStartNow] = useState("startNow");
  const [title] = useState("");
  const [status, setStatus] = useState("active");
  const [subCategories, setSubCategories] = useState([]);
  const [jobType, setJobType] = useState("job");
  const userProfile = useUserProfile();

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  //const [updateList, setUpdateList] = useState(false);

  const { job, isOpen, closeDialog, updateAdFunc } = props;

  const getState = () => {
    return {
      county,
      description,
      errors,
      id,
      jobLength,
      municipality,
      userProfile,
    };
  };

  useEffect(() => {
    if (job) {
      setCategory(job.category);
      setSubCategories(job.subCategories || []);
      setCounty(job.county);
      setDescription(job.description);
      setId(job.id);
      setIsZeroSix(job["id06"]);
      //setJobLength(job.jobLength);
      setMunicipality(job.municipality);
      setStatus(job.status);
      setStartDate(job.startDate);
      setStartNow(job.startNow);
      if (job.jobType) {
        setJobType(job.jobType);
      }
    }
  }, []);

  async function handleSubmit() {
    const state = getState();
    const isValid = validateForm(setErrors, state);
    //console.log("isValid: ", isValid);
    if (isValid === false) {
      return;
    }
    if (userProfile) {
      const obj = {
        category,
        subCategories,
        company: userProfile.company,
        county,
        description,
        id06: isZeroSix,
        municipality,
        startDate,
        startNow,
        status,
        title,
        jobType,
        userId: userProfile.id,
        userMail: userProfile.email,
      };

      updateAdFunc(obj, id, props.closeDialog);
    }
  }

  const municipalitiesOrg = kommuner.filter((kommun) => {
    if (kommun.admin === county) {
      return true;
    }
    return false;
  });
  const municipalities = municipalitiesOrg.map((kommun) => {
    return kommun.name;
  });
  municipalities.push(" - ");
  municipalities.sort();
  /*
  const thirtyDays = [];
  for (let i = 1; i < 31; i++) {
    thirtyDays.push(i);
  }
*/
  const heading = id ? "UPPDATERA ANNONS" : "LÄGG IN ANNONS";
  const buttonText = id ? "SPARA" : "LÄGG IN ANNONS";

  return (
    <>
      <div>
        <ThemeProvider theme={theme}>
          <Dialog
            open={isOpen}
            onClose={closeDialog}
            aria-labelledby="form-dialog-title"
            fullScreen={fullScreen}
          >
            {!fullScreen && (
              <DialogTitle id="form-dialog-title">{heading}</DialogTitle>
            )}
            {fullScreen && (
              <AppBar
                style={{ position: "relative", marginBottom: theme.spacing(2) }}
              >
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={closeDialog}
                    aria-label="close"
                  >
                    <Close />
                  </IconButton>
                  <Typography
                    variant="subtitle1"
                    style={{
                      marginLeft: theme.spacing(2),
                      flex: 1,
                    }}
                  >
                    {heading}
                  </Typography>

                  <Button
                    color="inherit"
                    autoFocus
                    variant="outlined"
                    onClick={handleSubmit}
                  >
                    {buttonText}
                  </Button>
                </Toolbar>
              </AppBar>
            )}
            <DialogContent>
              <div>
                <Grid container spacing={2} pt={2}>
                  <Grid item xs={12} sm={12}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Typ av Annons</FormLabel>
                      <RadioGroup
                        row
                        aria-label="jobtype"
                        name="controlled-radio-buttons-group"
                        value={jobType}
                        onChange={(event) => {
                          setJobType(event.target.value);
                        }}
                      >
                        {Object.keys(getJobTypes()).map(function (type) {
                          const job = getJobTypeById(type);
                          //console.log("job: ", job);
                          //console.log("type: ", type);
                          return (
                            <FormControlLabel
                              key={type}
                              value={type}
                              control={<Radio />}
                              label={job.label}
                            />
                          );
                        })}
                      </RadioGroup>
                    </FormControl>

                    {/*<FormControl variant="outlined" color="primary">
                      <InputLabel id="jobType">Typ av annons</InputLabel>
                      <Select
                        native
                        label="Välj annonstyp"
                        value={jobType}
                        onChange={(event) => {
                          setJobType(event.target.value);
                        }}
                      >
                        {Object.keys(getJobTypes()).map(function (type) {
                          const job = getJobTypeById(type);
                          //console.log("job: ", job);
                          //console.log("type: ", type);
                          return (
                            <option key={type} value={type}>
                              {job.label}
                            </option>
                          );
                        })}
                      </Select>
                      </FormControl>*/}
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl variant="outlined" color="primary">
                      <InputLabel id="jobLength">Kategori</InputLabel>
                      <Select
                        native
                        label="Välj kategori"
                        value={category}
                        onChange={(event) => {
                          setCategory(event.target.value);
                          setSubCategories([]);
                        }}
                      >
                        {Object.keys(getCategories()).map(function (
                          categoryId
                        ) {
                          const category = getCategoryById(categoryId);

                          return (
                            <option key={categoryId} value={categoryId}>
                              {category.label}
                            </option>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <SubCategories
                      categoryId={category}
                      values={subCategories}
                      onChange={(values) => {
                        setSubCategories(values);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      color="primary"
                      label="Beskrivning"
                      variant="outlined"
                      multiline
                      rows="4"
                      error={!!errors.description}
                      helperText={errors.description}
                      fullWidth={true}
                      value={description}
                      onChange={(event) => setDescription(event.target.value)}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <LocationSelect
                      label="Välj län"
                      options={counties}
                      error={!!errors.location}
                      helperText={errors.location}
                      value={county}
                      onChange={(value) => {
                        setMunicipality(" - ");
                        setCounty(value);
                      }}
                    />
                    <br />
                    <LocationSelect
                      label="Välj kommun"
                      options={municipalities}
                      error={!!errors.municipality}
                      helperText={errors.municipality}
                      value={municipality}
                      onChange={(value) => {
                        setMunicipality(value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormLabel component="legend">Jobb start</FormLabel>
                    <FormHelperText>
                      När ska jobbet starta? Välj antingen omgående eller ett
                      specifikt startdatum.
                    </FormHelperText>
                    <RadioGroup
                      aria-label="jobStart"
                      name="jobStart"
                      value={startNow}
                      onChange={(event) => {
                        if (event.target.value === "startNow")
                          setStartNow("startNow");
                        else setStartNow("startDate");
                      }}
                    >
                      <FormControlLabel
                        value="startNow"
                        control={<Radio />}
                        label="Omgående"
                      />
                      <FormControlLabel
                        value="startDate"
                        control={<Radio />}
                        label="Specifikt startdatum"
                      />
                    </RadioGroup>
                    {startNow === "startDate" && (
                      <LocalizationProvider dateAdapter={DateAdapter}>
                        <MobileDatePicker
                          renderInput={(params) => <TextField {...params} />}
                          id="date-picker-dialog"
                          mask="__.__.____"
                          label="Startdatum"
                          inputFormat="YYYY-MM-DD"
                          inputVariant="outlined"
                          required
                          value={new Date(startDate)}
                          onChange={(asdf) => {
                            const date = new Date(asdf)
                              .toISOString()
                              .substring(0, 10);
                            setStartDate(date);
                          }}
                        />
                      </LocalizationProvider>
                    )}
                    {/** 
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={sv}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Startdatum"
                        format="yyyy-MM-dd"
                        inputVariant="outlined"
                        required
                        value={new Date(startDate)}
                        onChange={(asdf) => {
                          const date = new Date(asdf)
                            .toISOString()
                            .substring(0, 10);
                          setStartDate(date);
                        }}
                      />
                    </MuiPickersUtilsProvider>
                    */}
                  </Grid>
                  {/*
                  <Grid item xs={6} sm={4}>
                    <FormControl variant="outlined">
                      <InputLabel id="jobLength">Jobblängd i dagar</InputLabel>
                      <Select
                        value={jobLength}
                        label="Jobblängd i dagar"
                        labelId="jobLength"
                        onChange={(event) =>
                          setJobLength(parseInt(event.target.value))
                        }
                        variant="outlined"
                        error={!!errors.jobLength}
                        helperText={errors.jobLength}
                        style={{ width: 300 }}
                      >
                        {thirtyDays.map(function (value) {
                          return (
                            <MenuItem key={value} value={value}>
                              {value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  */}
                  <Grid item xs={12} sm={12}>
                    <FormControlLabel
                      value={isZeroSix}
                      label="ID06 behövs"
                      labelPlacement="end"
                      color="secondary"
                      control={
                        <Switch
                          variant="outlined"
                          checked={isZeroSix}
                          onChange={(event) =>
                            setIsZeroSix(event.target.checked)
                          }
                          name="ID06 krävs"
                        />
                      }
                    />
                  </Grid>
                </Grid>

                <Notification notify={notify} setNotify={setNotify} />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog} color="primary">
                Avbryt
              </Button>
              <Button variant="outlined" color="primary" onClick={handleSubmit}>
                {buttonText}
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </div>
    </>
  );
}
